<nz-spin [nzSpinning]="loading$ | async">
  <div>
    <form nz-form class="form" nzLayout="horizontal" [formGroup]="lmsForm">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="deadline">
            Default deadline date (days from the date assigned)</nz-form-label
          >
          <nz-form-control nzErrorTip="Please enter the deadline date.">
            <input
              name="warningValid"
              type="text"
              nz-input
              id="deadline"
              formControlName="defaultLmsDeadlineDays"
              placeholder="Enter deadline date"
              [mask]="'000'"
              [validation]="false"
              appAllowOnlyValidNumbers
              (input)="validateInput($event)" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item></nz-form-item>
        <nz-form-item>
          <span nz-checkbox formControlName="sendLmsDeadlineEmails">
            Send due date/expiry email reminders</span
          >
        </nz-form-item>
      </div>
      <div
        class="display-flex btn-gap"
        [ngClass]="{ 'drawer-footer option-footer': !isMangeOption }">
        <div class="footer-left"></div>
        <div class="footer-right">
          <button
            nz-button
            type="button"
            nzType="primary"
            (click)="submitForm()"
            [disabled]="lmsForm.invalid">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</nz-spin>
